import { useEffect, useState } from "react";
import * as d3 from "d3";
import Image from './images/image.jsx';
import diamondData from './../../../data/diamond_data.js';

function Images (props) {

  const data = props.data

  const size = 10
  const prompts = ['gen00', 'gen01', 'gen02', 'gen10', 'gen11', 'gen12', 'gen20', 'gen21', 'gen22', 'nonbinary', 'queer']

  function getLabel (id) {
    if (['queer', 'nonbinary'].includes(id)) {
        if (id === 'queer') return 'Genderqueer person'
        else if (id === 'nonbinary') return 'Nonbinary person'
    }
    else return diamondData.find(el => el.id === id).name
  }

  useEffect(() => {

  });

  return (
    <div id="imageset" className="table">
      {prompts.map((el,i) => {
        return <div 
          key={i}
          >
          <div style={{
            padding: '2em 0 0.5em 0'
          }}>{getLabel(el)}</div>
          <div style={{
            display: 'flex',
            gap: '0.5em'
          }}>
            {data.filter(item => item.prompt === getLabel(el)).map((item,index) => {
              return (<Image
                data={item}
                key={index}
                size={size}
              />)
            })}
          </div>
            
        </div>
      })}

    </div>
  );
}

export default Images;
